import pathOr from 'ramda/src/pathOr'
import isNil from 'ramda/src/isNil'
import reduce from 'ramda/src/reduce'
import pipe from 'ramda/src/pipe'
import map from 'ramda/src/map'
import { formStoreLenses } from 'root/src/client/logic/form/lenses'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

const { pathOrFormInputs } = formStoreLenses

export default (state, props) => {
	const { moduleKey, moduleId, stepId } = props
	const moduleDataPath = stepId ? [moduleId, 'steps', stepId, 'fields'] : [moduleId, 'fields']
	const fieldsDefaults = pipe(
		pathOr([], moduleDataPath),
		map(field => (typeof field === 'function' ? field(state, props) : field)),
		reduce(
			(acc, { default: fieldDefault, fieldId, options }) => {
				if (options) {
					return { ...acc, [fieldId]: options[0] }
				}
				if (!isNil(fieldDefault)) {
					return { ...acc, [fieldId]: fieldDefault }
				}
				return acc
			}, {},
		),
	)(moduleDescriptions)

	return {
		...fieldsDefaults,
		...pathOrFormInputs(
			moduleKey, {}, state,
		),
	}
}
